module.exports = __webpack_public_path__ + "static/img/teBuContent1.3edaa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent1.png
// module id = HbQs
// module chunks = 2